<template>
  <div class="reg_form_box">
    <template v-if="form_step == 1">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Which of the following best describes you?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="buyer_type"
                v-model="buyer_type"
                class="custom-control-input"
                value="Buyer, looking to buy a property for him/herself"
              />
              <label class="custom-control-label" for="customRadio1">
                I am a buyer looking
                to buy a property for myself.
              </label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="buyer_type"
                v-model="buyer_type"
                class="custom-control-input"
                value="Investor, wants to buy property for investment"
              />
              <label class="custom-control-label" for="customRadio2">
                I am an investor
                wants to buy property for investment.
              </label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio3"
                name="buyer_type"
                v-model="buyer_type"
                class="custom-control-input"
                value="Group investor, wants to contribute funding for Group investment"
              />
              <label class="custom-control-label" for="customRadio3">
                I am group investor,
                I want to contribute my funding for Group investment.
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" :disabled="step_one_invalid" @click="handleFormStep">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 2">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What is your approximate net worth?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio4"
                name="net_worth"
                v-model="net_worth"
                class="custom-control-input"
                value="$500k or less"
              />
              <label class="custom-control-label" for="customRadio4">$500k or less</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="net_worth"
                v-model="net_worth"
                class="custom-control-input"
                value="$500k - $1M"
              />
              <label class="custom-control-label" for="customRadio5">$500k - $1M</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio6"
                name="net_worth"
                v-model="net_worth"
                class="custom-control-input"
                value="$1M - $5M"
              />
              <label class="custom-control-label" for="customRadio6">$1M - $5M</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio7"
                name="net_worth"
                v-model="net_worth"
                class="custom-control-input"
                value="$5M & above"
              />
              <label class="custom-control-label" for="customRadio7">$5M & above</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio8"
                name="net_worth"
                v-model="net_worth"
                class="custom-control-input"
                value="Prefer not to say"
              />
              <label class="custom-control-label" for="customRadio8">I prefer not to say</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" @click="handleFormStep" :disabled="step_two_invalid">
                Continue
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 3">
      <form>
        <div class="sell_home_form_box">
          <div class="sell_home_form" id="form3">
            <div class="form-row">
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Annual household Income"
                    name="annual-income"
                    v-model="annual_income"
                  />
                  <span>
                    <i class="fas fa-info-circle"></i>Enter your Annual Income before taxes. If you're buying with someone else, enter their income too.
                  </span>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Down Payment"
                    name="down-pay"
                    v-model="down_pay"
                  />
                  <span>
                    <i class="fas fa-info-circle"></i>The amount you can pay in cash when you close on your new home.
                  </span>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Monthly Bills"
                    name="monthly-bills"
                    v-model="monthly_bills"
                  />
                  <span>
                    <i class="fas fa-info-circle"></i>Include recurring obligations like car loans, student loans or alimony, but not everyday costs like groceries.
                  </span>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="input_star">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Where are you buying?(City, neighborhood or Zip)"
                    name="buy-location"
                    v-model="buy_location"
                  />
                  <span>
                    <i class="fas fa-info-circle"></i>Tell us where are you looking to calculate property tax and see homes within your budget.
                  </span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form_submit_button">
                  <button type="button" class="form_back prev_form1" @click="backFormStep">
                    <span>
                      <i class="fas fa-chevron-left"></i>
                    </span> Back
                  </button>
                  <button type="button" class="next_form1" :disabled="step_three_invalid" @click="handleFormStep">
                    Continue
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-else-if="form_step == 4">
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>What's your credit score? It's ok to estimate.</h1>
        <span>
          <i class="fas fa-info-circle"></i>Your credit score affects the loan programs and interest rates you mak qualify for, as well as the amount you'll need to put down.
        </span>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="credit"
                v-model="credit"
                class="custom-control-input"
                value="Excellent"
              />
              <label class="custom-control-label" for="customRadio1">Excellent ( 720 and above )</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="credit"
                v-model="credit"
                class="custom-control-input"
                value="Good"
              />
              <label class="custom-control-label" for="customRadio5">Good ( 660 - 719 )</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio6"
                name="credit"
                v-model="credit"
                class="custom-control-input"
                value="Average"
              />
              <label class="custom-control-label" for="customRadio6">Average ( 620 - 659 )</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio7"
                name="credit"
                v-model="credit"
                class="custom-control-input"
                value="Poor"
              />
              <label class="custom-control-label" for="customRadio7">Poor ( 580 - 619 )</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio8"
                name="credit"
                v-model="credit"
                class="custom-control-input"
                value="Bad"
              />
              <label class="custom-control-label" for="customRadio8">Bad ( 579 or below )</label>
            </div>
          </div>
        </div>
      </form>
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Are you self-employed?</h1>
      </div>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-4">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio4"
                name="employment-status"
                v-model="employment_status"
                class="custom-control-input"
                value="Yes"
              />
              <label class="custom-control-label" for="customRadio4">Yes</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="employment-status"
                v-model="employment_status"
                class="custom-control-input"
                value="No"
              />
              <label class="custom-control-label" for="customRadio5">No</label>
            </div>
          </div>
        </div>
      </form>
      <div class="form-row">
        <div class="col-md-12">
          <div class="form_submit_button">
            <button type="button" class="form_back prev_form1" @click="backFormStep">
              <span>
                <i class="fas fa-chevron-left"></i>
              </span> Back
            </button>
            <button type="button" @click="handleFormStep" :disabled="step_four_invalid">
              Continue
              <span>
                <i class="fas fa-chevron-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="reg_form_box_title agent_form_pat_title">
        <h1>Where should we contact you if we need more information?</h1>
      </div>
      <form action="#">
        <div class="col-md-12 mb-4">
          <div class="input_star">
            <input
              type="text"
              class="form-control"
              placeholder="Full Name"
              name="contact-name"
              v-model="contact_name"
            />
          </div>
        </div>
        <div class="col-md-12 mb-4">
          <div class="input_star">
            <input
              type="text"
              class="form-control"
              placeholder="Email Address"
              name="contact-email"
              v-model="contact_email"
            />
          </div>
        </div>
        <div class="col-md-12 mb-4">
          <div class="input_star">
            <input
              type="text"
              class="form-control"
              placeholder="Phone Number"
              name="contact-phone"
              v-model="contact_phone"
            />
          </div>
        </div>
      </form>
      <div class="mb-4">
        <span>
          <i class="fas fa-info-circle"></i>&nbsp;By clicking
          <q>Confirm</q> I consent to receive marketing calls and texts from RedBuyers and its affiliates to the number provided including by automated means. I may opt out at any time and consent is not a condition of purchase.
        </span>
      </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form_submit_button">
              <button type="button" class="form_back prev_form1" @click="backFormStep">
                <span>
                  <i class="fas fa-chevron-left"></i>
                </span> Back
              </button>
              <button type="button" @click.prevent="" :disabled="step_five_invalid">
                Confirm
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
    </template>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "RequestHomeForm",
  data() {
    return {
      form_step: 1,
      buyer_type: "",
      net_worth: "",
      annual_income: "",
      down_pay: "",
      monthly_bills: "",
      buy_location: "",
      credit: "",
      employment_status: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      processing: false
    };
  },
  validations: {
    buyer_type: {
      required
    },
    net_worth: {
      required
    },
    annual_income: {
      required
    },
    down_pay: {
      required
    },
    monthly_bills: {
      required
    },
    buy_location: {
      required
    },
    credit: {
      required
    },
    employment_status: {
      required
    },
    contact_name: {
      required
    },
    contact_email: {
      required,
      email
    },
    contact_phone: {
      required,
      minLength: minLength(10)
    },
  },
  methods: {
    handleFormStep() {
      this.$v.$touch();
      this.form_step = this.form_step + 1;
    },
    backFormStep() {
      if (this.form_step > 1) {
        this.form_step = this.form_step - 1;
      }
    },
    submitBuyerLead() {
      if(this.$v.$invalid) {
        alert('Please check all the mandatory fields marked with *');
      } else {
        this.processing = true;
        const formData = new FormData();

        formData.append("buyer_type", this.buyer_type);
        formData.append("net_worth", this.net_worth);
        formData.append("annual_income", this.annual_income);
        formData.append("down_pay", this.down_pay);
        formData.append("monthly_bills", this.monthly_bills);
        formData.append("buy_location", this.buy_location);
        formData.append("credit", this.credit);
        formData.append("employment_status", this.employment_status);
        formData.append("contact_name", this.contact_name);
        formData.append("contact_email", this.contact_email);
        formData.append("contact_phone", this.contact_phone);
      }
    }
  },
  computed: {
    step_one_invalid() {
      if(!this.$v.buyer_type.required) {
        return true;
      } else {
        return false;
      }
    },
    step_two_invalid() {
      if(this.$v.net_worth.$error) {
        return true;
      } else {
        return false;
      }
    },
    step_three_invalid() {
      if(this.$v.annual_income.$error || this.$v.down_pay.$error || this.$v.monthly_bills.$error || this.$v.buy_location.$error) {
        return true;
      } else {
        return false;
      }
    },
    step_four_invalid() {
      if(this.$v.credit.$error || this.$v.employment_status.$error) {
        return true;
      } else {
        return false;
      }
    },
    step_five_invalid() {
      if(this.$v.contact_name.$error || this.$v.contact_email.$error || this.$v.contact_phone.$error) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>